import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    public currentTheme = signal<'light' | 'dark'>('light');

    initTheme() {
        const savedTheme = localStorage.getItem('theme') as 'light' | 'dark';
        this.setTheme(savedTheme || 'light');
    }

    setTheme(theme: 'light' | 'dark') {
        this.currentTheme.set(theme);
        localStorage.setItem('theme', theme);
        document.body.setAttribute('data-theme', theme);
    }

    toggleTheme() {
        this.setTheme(this.currentTheme() === 'light' ? 'dark' : 'light');
    }
}
